// src/services/supabase.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false, // Only needed for OAuth/magic-link flows
    // Let Supabase manage its own storage key (namespaced by project ref)
    // Previously hardcoded as 'supabase.auth.token' which caused stale session issues
  }
});

/**
 * Targeted session reset — programmatic equivalent of "clear browser history"
 * but only removes Supabase auth keys from localStorage.
 * 
 * Call this when:
 * - Role fetch times out (likely stale/corrupt token)
 * - Auth-related errors during profile queries
 * - User is stuck on loading screen
 */
export const resetAuthSession = async () => {
  // 1. First, clear ALL Supabase-related keys BEFORE signOut
  //    (signOut can re-write keys, so we clear first and after)
  const clearSupabaseKeys = () => {
    try {
      const allKeys = Object.keys(window.localStorage);
      const supabaseKeys = allKeys.filter(k => 
        k.startsWith('sb-') || 
        k.includes('supabase') || 
        k.includes('auth-token')
      );
      console.log('Clearing localStorage keys:', supabaseKeys);
      supabaseKeys.forEach(k => window.localStorage.removeItem(k));
    } catch (e) {
      console.error('Error clearing keys:', e);
    }
  };

  clearSupabaseKeys();

  // 2. Try a clean sign-out through the SDK
  try {
    await supabase.auth.signOut({ scope: 'local' });
  } catch (_) {}

  // 3. Clear again in case signOut re-wrote anything
  clearSupabaseKeys();

  console.log('Remaining localStorage keys:', Object.keys(window.localStorage));
};